<div class="grid place-items-center">
    <div class="facebook-card py-5 bg-white w-full max-w-2xl hidden">
        <div class="card-body px-0">
            <!-- User Info -->
            <div class="flex flex-col md:flex-row items-center md:items-start px-4">
                <!-- Left Column -->
                <div class="w-full md:w-2/3">
                    <div class="flex items-center mb-1">
                        <img src="{{thumbnailFilePath}}" class="rounded-full me-2 user-avatar" alt="User Avatar" />
                        <div>
                            <p class="mb-0 font-15 bold-600">{{postFeed}}</p>
                            <small class="text-muted flex items-center">
                                {{formattedDate}} - &nbsp;<img src="assets/icons/world.png" class="me-2 world-icon"
                                    alt="World Icon" />
                            </small>
                        </div>
                    </div>
                </div>
                <!-- Right Column -->
                <div class="w-full md:w-1/3 flex justify-end mt-2 md:mt-0">
                    <img src="assets/icons/dots.png" class="rounded-full mt-2 me-4 dots-icon cursor-pointer"
                        alt="Dots Icon" />
                </div>
            </div>

            <!-- Post Content -->
            <div class="px-4 my-2 post-description" [attr.dir]="textDirection">
                <p>{{postDescription}}
                    <span class="text-muted" style="font-weight: 800;"
                        *ngIf="totChars > 250 && socialTag != 'fbfirstcomment'"> &nbsp; View more</span>
                    <span class="text-muted " style="font-weight: 800;" *ngIf="socialTag == 'fbfirstcomment' ">
                        <img src="assets/icons/link-icon.png" class="facebook-like-icon ms-0 inline -mt-2"
                            alt="Link Icon" />
                        Link in first comment</span>
                </p>
            </div>
            <!-- VIDEO VERSION -->
            <div *ngIf="isVideo" class="px-0 mb-4">
                <div class="flex items-center justify-center facebook-image-container mb-2">

                    <!-- YouTube -->
                    <ng-container *ngIf="isYouTube; else mp4Video">
                        <div class="w-full aspect-video rounded-lg overflow-hidden">
                            <iframe class="w-full h-full" [src]="youTubeEmbedUrl" frameborder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                allowfullscreen>
                            </iframe>
                        </div>
                    </ng-container>


                    <!-- MP4 / direct video -->
                    <ng-template #mp4Video>
                        <div class="fb-video">
                            <video
                            class="fb-video__el"
                            [src]="videoUrl"
                            [attr.poster]="
                                mainImageUrl && !mainImageUrl.includes('assets/images/na.png')
                                ? mainImageUrl
                                : null
                            "
                            controls
                            playsinline
                            preload="metadata"
                            >
                            </video>
                        </div>
                        </ng-template>


                </div>
            </div>


            <!-- Photolink Tag -->
            <div *ngIf="socialTag == 'photolink'" class="photolink-container flex items-center justify-center h-full">
                <img src="{{mainImageUrl ? mainImageUrl : './assets/images/na.png'}}" alt="" class="">
            </div>

            <div class="post-title px-4 my-4" *ngIf="socialTag == 'photolink'">
                <p><span class="font-16 text-muted">{{siteDomain}}</span></p>
                <p class="mt-2"><span class="font-15 bold-600">{{postTitle}}</span></p>
            </div>

            <!-- Photopost Tag -->
            <div *ngIf="!isVideo && switchboardImage == 0">
                <div class="flex items-center justify-center facebook-image-container mb-2 relative h-[750px]"
                    *ngIf="socialTag != 'photolink'">

                    <img src="{{mainImageUrl}}" alt="" class="w-full h-full object-cover">

                    <!-- Caption -->
                    <div class="image-container-content text-center py-4 px-4">
                        <h3 class="image-caption px-6 text-white mt-3">
                            {{postTitle}}
                        </h3>

                        <hr class="border-t-0 h-1 opacity-100 my-4" />

                        <!-- Additional Text -->
                        <p class="mb-0 font-medium text-white bold-500">
                            This is a preview image provided by <em>Publio.ai</em>
                        </p>
                    </div>
                </div>
            </div>

            <div *ngIf="!isVideo && switchboardImage == 1">
                <div class="flex items-center justify-center facebook-image-container mb-2"
                    *ngIf="socialTag != 'photolink'">
                    <img src="{{mainImageUrl}}" alt="">
                </div>
            </div>


            <!-- Likes, Comments, Shares -->
            <div class="px-4 mb-2">
                <div class="flex flex-col md:flex-row justify-between items-center">
                    <!-- Likes -->
                    <div class="flex items-center mb-2 md:mb-0">
                        <img src="assets/icons/facebook-like.png" class="facebook-like-icon" alt="Like Image" />
                        <img src="assets/icons/facebook-heart.png" class="facebook-like-icon ms-0" alt="Heart Image" />
                        <span class="ms-1">#</span>
                    </div>
                    <!-- Comments & Shares -->
                    <div class="text-muted flex items-center">
                        <span class="me-2"># comments</span>
                        <span># shares</span>
                    </div>
                </div>
            </div>

            <!-- Divider -->
            <div class="px-4 mb-4">
                <hr class="border-t border-gray-300" />
            </div>

            <!-- Engagement Buttons -->
            <div class="flex justify-center items-center mt-3 social-text px-4">
                <button class="flex items-center focus:outline-none me-4">
                    <img src="assets/icons/like.png" class="facebook-like-icon me-1" alt="Like Image" />
                    <span>Like!</span>
                </button>
                <button class="flex items-center focus:outline-none me-4">
                    <img src="assets/icons/comment.png" class="facebook-like-icon me-1" alt="Comment Image" />
                    <span>Comment</span>
                </button>
                <button class="flex items-center focus:outline-none me-4">
                    <img src="assets/icons/share.png" class="facebook-like-icon me-1" alt="Share Image" />
                    <span>Share</span>
                </button>
            </div>
        </div>
    </div>
</div>